module.exports = __webpack_public_path__ + "static/media/check.74f5f35a.svg";